import React from "react";
import banner1 from "../assets/images/banner/banner-01.png";
import banner2 from "../assets/images/banner/banner-02.png";
import banner3 from "../assets/images/banner/banner-03.png";
import banner4 from "../assets/images/banner/banner-04.png";
import banner5 from "../assets/images/banner/banner-05.png";
import banner6 from "../assets/images/banner/banner-06.png";
function Carousel() {
  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide"
      data-ride="carousel"
    >
      <ol className="carousel-indicators">
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="0"
          className="active"
        ></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
      </ol>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img className="d-block w-100" src={banner1} alt="First slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={banner2} alt="Second slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={banner3} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={banner4} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={banner5} alt="Third slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={banner6} alt="Third slide" />
        </div>
      </div>
      <a
        className="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a
        className="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  );
}

export default Carousel;
